import yup from 'yup';
import moment from 'moment';

import { API_FORMAT } from 'constants/dates';

yup.addMethod(yup.string, 'Integer', function(message = 'Это поле должно быть числом') {
    return this.test('Integer', message, function(value) {
        return !value || /\d/.test(value);
    });
});

yup.addMethod(yup.string, 'date', function(format = API_FORMAT, message = 'Неверный формат') {
    return this.test('date', message, function(value) {
        return value ? moment(value, format).isValid() : true;
    });
});



// WEBPACK FOOTER //
// ./src/utils/yupValidation.js